import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ups-section',
  templateUrl: './ups-section.component.html',
  styleUrls: ['./ups-section.component.scss']
})
export class UpsSectionComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
